import { Link } from "react-router-dom";
import Reveal from "@/components/feature/Reveal";

/**
 * 施術詳細ページ下部の控えめな関連リンク。
 * 大きなカードUIは使わず、細い罫線・テキストリンク・小さな矢印で構成する。
 * （お肌管理・再生医療・注入治療・二重目元と同じトーン）
 */
export default function TreatmentRelatedLinks({ items }: { items: { label: string; to: string }[] }) {
  return (
    <section className="border-t border-background-300/70 bg-background-50 py-16 md:py-20 lg:py-24">
      <div className="u-container">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-[1fr_1.8fr] md:gap-16 lg:gap-24">
          <Reveal>
            <div className="flex flex-col">
              <span className="en-eyebrow text-[10px] text-secondary-700 md:text-[11px]">RELATED LINKS</span>
              <span className="mt-5 block h-px w-10 bg-accent-500" />
              <h2 className="mt-6 font-heading text-[20px] leading-[1.6] text-foreground-950 md:text-[24px]">
                関連ページ
              </h2>
            </div>
          </Reveal>

          <Reveal delay={100}>
            <ul className="border-t border-foreground-950/12">
              {items.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="group flex items-center justify-between gap-4 border-b border-foreground-950/12 py-6 transition-colors"
                  >
                    <span className="font-heading text-[15px] text-foreground-900 transition-colors group-hover:text-accent-700 md:text-base">
                      {link.label}
                    </span>
                    <i
                      className="ri-arrow-right-line text-base text-foreground-400 transition-transform group-hover:translate-x-1 group-hover:text-accent-700"
                      aria-hidden
                    />
                  </Link>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
}